var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 62625",
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.023,
    height: 33.237,
    viewBox: "0 0 33.023 33.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "wdo86i31pa",
    cx: 0.035,
    cy: 0.542,
    r: 0.973,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#ff9d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13054"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9221",
    d: "M3082.024 4523.118a16.512 16.512 0 1 1-16.512-16.618 16.324 16.324 0 0 1 10.258 3.606 16.607 16.607 0 0 1 6.254 13.012z",
    transform: "translate(-3049 -4506.5)",
    style: {
      fill: "url(#wdo86i31pa)"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13057"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13055",
    transform: "translate(19.955 11.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 166",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13056",
    transform: "translate(8.713 11.032)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 167",
    cx: 2.178,
    cy: 2.192,
    rx: 2.178,
    ry: 2.192
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13058"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9222",
    d: "M23.538 21.569a4.656 4.656 0 0 1-.843 2.121 6.213 6.213 0 0 1-1.757 1.556 8.425 8.425 0 0 1-4.5 1.2 9.119 9.119 0 0 1-4.5-1.2 6.211 6.211 0 0 1-1.756-1.556 3.99 3.99 0 0 1-.843-2.121.069.069 0 0 1 .07-.071h.07a6.091 6.091 0 0 0 3.233 2.334 8.744 8.744 0 0 0 1.827.494 8.542 8.542 0 0 0 1.9.142 16.977 16.977 0 0 0 1.9-.142 7.74 7.74 0 0 0 1.827-.494 6.949 6.949 0 0 0 3.232-2.334c.069 0 .069 0 .14.071z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.db486aaccdd8110cc6ffa62e81560681.svg";
export { ForwardRef as ReactComponent };